import { render, staticRenderFns } from "./GetAllUsersList.vue?vue&type=template&id=04b78d24&scoped=true"
import script from "./GetAllUsersList.vue?vue&type=script&lang=js"
export * from "./GetAllUsersList.vue?vue&type=script&lang=js"
import style0 from "./GetAllUsersList.vue?vue&type=style&index=0&id=04b78d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b78d24",
  null
  
)

export default component.exports